/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import InfinityLoader from '@/components/common/infinityLoader'
import useTrainingExperienceForm from '@/hooks/Dashoboard/Members/Profile/TrainingExperiences/useTrainingExperienceForm'
import {
  TrainingExperience,
} from '@/types/graphql/types'
import { Button, Group, LoadingOverlay, TextInput } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const TrainingExperienceForm = ({
  item,
  handleUpdate,
}: {
  item: TrainingExperience | null
  handleUpdate: ({ newTE }: { newTE: TrainingExperience[] }) => void
}) => {
  const { t } = useTranslation('common')
  const { submit, loading, form } = useTrainingExperienceForm({
    item,
    handleUpdate,
  })
  return (
    <form onSubmit={form.onSubmit(submit)} className="relative">
      <LoadingOverlay
        loader={<InfinityLoader variant="lg" />}
        visible={loading}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <TextInput
          label={t('eventName')}
          {...form.getInputProps('eventName')}
        />
        <TextInput
          label={t('executingAgency')}
          {...form.getInputProps('executingAgency')}
        />
      </div>
      <Group position="center" pt={10}>
        <Button type="submit">{t('save')}</Button>
      </Group>
    </form>
  )
}

export default TrainingExperienceForm
